import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-quote-empty-state',
  templateUrl: './quote-empty-state.component.html',
  styleUrls: ['./quote-empty-state.component.css'],
  standalone: false
})
export class QuoteEmptyStateComponent {
  @Input() isQuotesEnabled: boolean = true;
  @Input() activeTab: 'new' | 'received' | 'waiting' = 'new';

}